export const includesIgnoreCase = (data: string[], value: string) =>
  data.some((item) => item.toLowerCase() === value.toLowerCase())
